import React, {useContext, useEffect, useState} from 'react'
import Lottie from 'lottie-light-react'
import {
    Box,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    TextField
} from '@mui/material'
import Button from '../button/Button.jsx'
import ListHistory from './listHistory/ListHistory.jsx'
import ListFlavor from './listFlavor/ListFlavor.jsx'
import Order from './order/Order.jsx'

import {getLocal, getSession, setLocal} from '../../hooks/useStorage/useStorage.jsx'

import {ItemBagContext} from '../../context/ItemBagContext.jsx'
import {ShoppingCartContext} from '../../context/ShoppingCartContext.jsx'

import {
    capitalizeFirstLetter,
    cleanTextToNumbers,
    isCNPJ,
    isCPF,
    isEmpty,
    isMobile,
    maskCPF_CNPJ, maskInternationalPhone
} from 'react-lf-tools'

import {
    general as textsGeneral,
    itemBag as textsItemBag,
    shoppingCart as textsShoppingCart,
    consultation as textsConsultation,
    addCard as textsAddCard
} from '../../translate/Translate.jsx'

import loading from '../../assets/loading.json'
import checked from '../../assets/checked.json'
import error from '../../assets/error.json'

import {
    AddRounded as AddIcon,
    RemoveRounded as RemoveIcon,
    ArrowBackRounded as ArrowBackIcon,
    DeleteRounded,
    RestaurantRounded,
    Receipt,
    CurrencyExchangeRounded,
    ExpandMoreRounded,
    CheckCircleRounded,
    CreditCardRounded as CreditCardIcon,
    Pix as PixIcon
} from '@mui/icons-material'

import {motion} from 'framer-motion'

import ButtonTimer from '../buttonTimer/ButtonTimer.jsx'
import PaymentTypes from './paymentTypes/PaymentTypes.jsx'
import Pix from './pix/Pix.jsx'

import './dialogs.scss'
import AddCardCredit from "./addCardCredit/AddCardCredit.jsx";
import {isPhoneInternational} from "../../utils/utils.jsx";

export const DialogLanguage = ({open, onClose}) => {
    const handleClickLanguage = (value) => {
        switch (value) {
            case 'english':
                setLocal('language', 'en')
                window.location.reload(false)
                break
            case 'spanish':
                setLocal('language', 'es')
                window.location.reload(false)
                break
            default:
                setLocal('language', 'pt')
                window.location.reload()
                break
        }
    }

    return <Dialog open={open} onClose={onClose}>
        <DialogTitle>
            {textsGeneral.language}
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                {textsGeneral.chooseLanguage}
            </DialogContentText>
            <Button
                className={'button-dialog'}
                value={'portuguese'}
                title={textsGeneral.portuguese}
                onClick={handleClickLanguage}/>
            <Button
                className={'button-dialog'}
                value={'english'}
                title={textsGeneral.english}
                onClick={handleClickLanguage}/>
            <Button
                className={'button-dialog'}
                value={'spanish'}
                title={textsGeneral.spanish}
                onClick={handleClickLanguage}/>
        </DialogContent>
    </Dialog>
}

export const DialogConfirmation = ({open, onClose, onClick, title = '', message = '', yesNot = false, type}) => {
    const handleClose = _ => onClose()
    const handleClick = () => onClick(type)
    return <Dialog open={open} onClose={onClose}>
        <DialogTitle>
            {title}
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                {message}
            </DialogContentText>
            <div className={'div-dialog-confirmation'}>
                <Button
                    className={'button-dialog'}
                    variant={'outline'}
                    value={'cancel'}
                    title={yesNot ? textsGeneral.no : textsGeneral.cancel}
                    onClick={handleClose}/>
                <Button
                    className={'button-dialog'}
                    value={'confirm'}
                    title={yesNot ? textsGeneral.yes : textsGeneral.confirm}
                    onClick={handleClick}/>
            </div>
        </DialogContent>
    </Dialog>
}

export const DialogWarning = ({open, onClick, title = '', message = '', noButton = false}) => {
    const handleClick = (value) => onClick(value)
    return <Dialog open={open}>
        <DialogTitle>
            {title}
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                {message}
            </DialogContentText>
            <div className={'div-dialog-confirmation'}>
                {(!noButton) && <Button
                    className={'button-dialog'}
                    value={'confirm'}
                    title={textsGeneral.toClose}
                    onClick={handleClick}/>}
            </div>
        </DialogContent>
    </Dialog>
}

export const DialogCoupon = ({open, onClick, onClose, coupon, message}) => {
    const handleClick = () => onClick(coupon)
    return <Dialog open={open} onClose={onClose}>
        <DialogTitle>
            {textsGeneral.discountCoupon}
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                {message}
            </DialogContentText>
            <div className={'div-dialog-confirmation'}>
                <Button
                    className={'button-dialog'}
                    value={'confirm'}
                    title={textsGeneral.rescue}
                    onClick={handleClick}/>
            </div>
        </DialogContent>
    </Dialog>
}

export const DialogLoading = ({open, message}) => {
    return <Dialog open={open}>
        <DialogContent>
            <div className={'div-dialog-loading'}>
                <Lottie
                    animationData={loading}
                    className={'lottie-loading'}/>
                <label className={'label-dialog-loading'}>
                    {message}
                </label>
            </div>
        </DialogContent>
    </Dialog>
}

export const DialogProfile = ({open, onMessage, onClose, onClick}) => {
    const {name, cpf, phone} = getLocal('profile', {
        name: '',
        cpf: '',
        phone: ''
    })
    const [profile, setProfile] = useState({
        name: name,
        phone: phone,
        cpf: maskCPF_CNPJ(cpf)
    })
    const handleChange = (e) => {
        if (e.target.name === 'name') {
            setProfile({...profile, name: capitalizeFirstLetter(e.target.value)})
        } else if (e.target.name === 'phone') {
            setProfile({...profile, phone: (!!e.target.value) ? maskInternationalPhone(e.target.value) : ''})
        } else {
            setProfile({...profile, cpf: maskCPF_CNPJ(e.target.value.substring(0, 18))})
        }
    }
    const confirm = () => {
        if (isEmpty(profile.name)) return onMessage(textsGeneral.invalidName)
        if (!isEmpty(profile.phone) && !isPhoneInternational(profile.phone)) return onMessage(textsGeneral.invalidPhone)
        if (!!profile.cpf.length) {
            if (profile.cpf.length > 14) {
                if (!isCNPJ(profile.cpf)) return onMessage(textsGeneral.invalidCnpj)
            } else {
                if (!isCPF(profile.cpf)) return onMessage(textsGeneral.invalidCpf)
            }
        }
        profile.cpf = cleanTextToNumbers(profile.cpf)
        profile.phone = cleanTextToNumbers(profile.phone)
        onClick(profile)
    }
    return <Dialog open={open}>
        <DialogTitle>
            {textsGeneral.orderInformation}
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                {textsGeneral.warningInformation}
            </DialogContentText>
            <Box p={1}/>
            <TextField
                focused={true}
                value={profile.name}
                name={'name'}
                fullWidth={true}
                InputLabelProps={{shrink: true}}
                color={'secondary'}
                autoFocus={true}
                required={true}
                label={textsGeneral.name}
                placeholder={textsGeneral.name}
                onKeyDown={(event) => {
                    if (event.key === 'Enter') confirm()
                }}
                onChange={handleChange}
            />
            <Box p={1}/>
            <TextField
                value={profile.cpf}
                name={'cpf'}
                fullWidth={true}
                InputLabelProps={{shrink: true}}
                color={'secondary'}
                type={'tel'}
                label={textsGeneral.cpf}
                placeholder={textsGeneral.cpf}
                onKeyDown={(event) => {
                    if (event.key === 'Enter') confirm()
                }}
                onChange={handleChange}
            />
            <Box p={1}/>
            <TextField
                value={profile.phone}
                name={'phone'}
                fullWidth={true}
                InputLabelProps={{shrink: true}}
                color={'secondary'}
                required={true}
                type={'tel'}
                label={textsGeneral.phone}
                placeholder={textsGeneral.phone}
                onKeyDown={(event) => {
                    if (event.key === 'Enter') confirm()
                }}
                onChange={handleChange}
            />
            <div className={'div-dialog-confirmation'}>
                <Button
                    className={'button-dialog'}
                    variant={'outline'}
                    value={'confirm'}
                    title={textsGeneral.toClose}
                    onClick={() => onClose()}
                />
                <Button
                    className={'button-dialog'}
                    value={'confirm'}
                    title={textsGeneral.confirm}
                    onClick={() => confirm()}
                />
            </div>
        </DialogContent>
    </Dialog>
}

export const DialogDiscountCoupon = ({open, onMessage, onClose, onClick}) => {
    const {discountCoupon} = getSession('discountCoupon', {discountCoupon: ''})
    const [coupon, setCoupon] = useState(discountCoupon)
    const handleChange = (event) => setCoupon(event.target.value.toUpperCase())
    const confirm = () => {
        if (isEmpty(coupon))
            return onMessage(textsShoppingCart.invalidCoupon)
        onClick(coupon)
    }
    return <Dialog open={open}>
        <DialogTitle>
            {textsShoppingCart.discountCoupon}
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                {textsShoppingCart.validateCoupon}
            </DialogContentText>
            <Box p={1}/>
            <TextField
                value={coupon}
                fullWidth={true}
                InputLabelProps={{shrink: true}}
                onKeyDown={(event) => {
                    if (event.key === 'Enter') confirm()
                }}
                color={'secondary'}
                placeholder={textsShoppingCart.discountCoupon}
                label={textsShoppingCart.discountCoupon}
                onChange={handleChange}
            />
            <div className={'div-dialog-confirmation'}>
                <Button
                    className={'button-dialog'}
                    variant={'outline'}
                    title={textsGeneral.toClose}
                    onClick={() => onClose()}
                />
                <Button
                    className={'button-dialog'}
                    value={'confirm'}
                    title={textsGeneral.confirm}
                    onClick={() => confirm()}
                />
            </div>
        </DialogContent>
    </Dialog>
}

export const DialogSendingSuccess = ({open, onClick}) => {
    useEffect(() => {
        setTimeout(() => onClick(), 5000)
    }, [])
    return <Dialog open={open}>
        <DialogContent>
            <div className={'div-dialog-sending-success'}>
                <Lottie
                    animationData={checked}
                    className={'lottie-sending-success'}/>
                <label className={'label-dialog-loading'}>
                    {textsShoppingCart.orderSentSuccessfully}
                </label>
            </div>
            <Button
                style={{width: '100%'}}
                className={'button-dialog'}
                value={'cancel'}
                title={textsShoppingCart.orderSent}
                onClick={() => onClick()}
            />
        </DialogContent>
    </Dialog>
}

export const DialogErrorOrCancellation = ({open, onClick, message, title}) => {
    return <Dialog open={open}>
        <DialogContent>
            <div className={'div-dialog-sending-success'}>
                <Lottie
                    animationData={error}
                    className={'lottie-sending-success'}/>
                <label className={'label-dialog-loading'}>
                    {message}
                </label>
            </div>
            <Button
                className={'button-dialog'}
                value={'cancel'}
                title={title}
                onClick={() => onClick()}
            />
        </DialogContent>
    </Dialog>
}

export const DialogCashback = ({open, cashback, onClose, onClick}) => {

    const [amount, setAmount] = useState(cashback.rescue || '')
    const [finaleAmount, setFinalAmount] = useState(cashback.balance - cashback.rescue)

    const handleChange = event => {
        let value = parseFloat(event.target.value) || 0
        value = parseFloat(value.toFixed(2))
        if (value > cashback.balance) {
            setFinalAmount(0)
            setAmount(cashback.balance)
        } else {
            setFinalAmount((cashback.balance - value))
            setAmount(value || '')
        }
    }

    const confirm = () => onClick(parseFloat(amount || 0))

    return <Dialog open={open}>
        <DialogTitle>
            {textsShoppingCart.cashback}
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                {textsShoppingCart.wantToRescue}
            </DialogContentText>
            <Box p={1}/>
            <div className={'div-balances-cashback'}>
                <label className={'opening-balance'}>
                    {`${textsShoppingCart.initialBalance}: ${cashback.balance.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    })}`}
                </label>
                <Box p={1}/>
                <label className={'ending-balance'}>
                    {`${textsShoppingCart.finalBalance}: ${(finaleAmount).toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    })}`}
                </label>
            </div>
            <Box p={1}/>
            <TextField
                value={amount}
                fullWidth={true}
                InputLabelProps={{shrink: true}}
                color={'secondary'}
                type={'number'}
                label={textsShoppingCart.valueToBeRedeemed}
                placeholder={textsShoppingCart.valueToBeRedeemed}
                onKeyDown={(event) => {
                    if (event.key === 'Enter') confirm()
                }}
                onChange={handleChange}
            />
            <div className={'div-dialog-confirmation'}>
                <Button
                    className={'button-dialog'}
                    variant={'outline'}
                    value={'cancel'}
                    title={textsGeneral.cancel}
                    onClick={onClose}/>
                <Button
                    className={'button-dialog'}
                    value={'confirm'}
                    title={textsGeneral.confirm}
                    onClick={() => confirm()}/>
            </div>
        </DialogContent>
    </Dialog>
}

export const DialogFlavor = ({open, flavorItems, onClick, onClose}) => {
    return <Dialog
        open={open}
        onClose={onClose}>
        <DialogTitle>
            {textsShoppingCart.flavorAssistant}
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                {textsShoppingCart.textAssistant}
            </DialogContentText>
            <ListFlavor listFlavor={flavorItems} onClick={onClick}/>
        </DialogContent>
    </Dialog>
}

export const DialogQuantity = ({open, onClick, onClose, product}) => {
    const {productQuantity, setProductQuantity, setAddItem, isAddItem, setSnackbar} = useContext(ItemBagContext)
    const [settings, setSettings] = useState({maximumQuantity: 100})
    const handleClickAdd = (amount = 1) => {
        if ((productQuantity + amount) > settings.maximumQuantity) return setSnackbar({
            open: true,
            message: `${textsItemBag.maximumQuantity}"${settings.maximumQuantity}"`
        })
        setAddItem(!isAddItem)
        setProductQuantity((productQuantity + amount))
    }
    const handleClickRemove = () => {
        if ((settings.minimumQuantity !== 1) && (productQuantity <= settings.minimumQuantity)) return setSnackbar({
            open: true,
            message: `${textsItemBag.minimumQuantity}"${settings.minimumQuantity}"`
        })
        if (productQuantity !== 1) {
            setAddItem(!isAddItem)
            setProductQuantity((productQuantity - 1))
        }
    }

    useEffect(() => checkQuantities(), [])

    const checkQuantities = () => {
        const maximumQuantityLocal = getLocal(`maximumQuantity=${product.sku}`)
        const maximumQuantity = !!maximumQuantityLocal ? maximumQuantityLocal : product.qtdeMaxAuto
        setSettings({maximumQuantity: maximumQuantity})
    }

    return <Dialog
        open={open}
        onClose={onClose}>
        <DialogTitle>
            {textsItemBag.quantity}
        </DialogTitle>
        <DialogContent>
            <div className={'div-amount-product'}>
                <div className={'left'}>
                    <IconButton onClick={handleClickRemove}>
                        <RemoveIcon className={'icon-information'}/>
                    </IconButton>
                </div>
                <div className={'center'} onClick={onClick}>
                    <label className={'label-amount'}>
                        {productQuantity}
                    </label>
                </div>
                <div className={'right'}>
                    <IconButton onClick={() => handleClickAdd(1)}>
                        <AddIcon className={'icon-information'}/>
                    </IconButton>
                </div>
            </div>
            <Box p={1}/>
            <div className={'div-quantitys'}>
                <div className={'row'}>
                    {(settings.maximumQuantity > 5) &&
                        <Button onClick={() => handleClickAdd(5)} className={'button'} title={'+ 5'}/>}
                    {(settings.maximumQuantity > 10) &&
                        <Button onClick={() => handleClickAdd(10)} className={'button'} title={'+ 10'}/>}
                </div>
                <div className={'row'}>
                    {(settings.maximumQuantity > 25) &&
                        <Button onClick={() => handleClickAdd(25)} className={'button'} title={'+ 25'}/>}
                    {(settings.maximumQuantity > 50) &&
                        <Button onClick={() => handleClickAdd(50)} className={'button'} title={'+ 50'}/>}
                </div>
            </div>
        </DialogContent>
    </Dialog>
}

export const DialogTable = ({open, onClose, onClick}) => {
    const [table, setTable] = useState(getSession('table', ''))
    const [error, setError] = useState(false)
    const handleChange = (e) => {
        const value = parseInt(e.target.value, 10)
        if (!value || value <= 0) {
            setTable('')
            return
        }
        setTable(e.target.value)
    }
    const confirm = () => {
        if (!!table) {
            setError(false)
            onClick(table)
        } else {
            setError(true)
        }
    }
    return <Dialog open={open}>
        <DialogTitle>
            {textsGeneral.table}
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                {textsGeneral.digitTable}
            </DialogContentText>
            <Box p={1}/>
            <TextField
                error={error}
                autoFocus={true}
                value={table}
                fullWidth={true}
                InputLabelProps={{shrink: true}}
                color={'secondary'}
                type={'number'}
                label={textsGeneral.numberTable}
                placeholder={textsGeneral.numberTable}
                onKeyDown={(event) => {
                    if (event.key === 'Enter') confirm()
                }}
                onChange={handleChange}
            />
            <div className={'div-dialog-confirmation'}>
                <Button
                    className={'button-dialog'}
                    variant={'outline'}
                    value={'cancel'}
                    title={textsGeneral.cancel}
                    onClick={onClose}/>
                <Button
                    className={'button-dialog'}
                    value={'confirm'}
                    title={textsGeneral.confirm}
                    onClick={() => confirm()}/>
            </div>
        </DialogContent>
    </Dialog>
}

export const DialogPermissionCamera = ({open, onClose, onClick}) => {
    return <Dialog open={open}>
        <DialogTitle>
            {textsGeneral.permission}
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                {textsGeneral.permissionMessage}
            </DialogContentText>
            <div className={'div-dialog-confirmation'}>
                <Button
                    className={'button-dialog'}
                    variant={'outline'}
                    value={'cancel'}
                    title={textsGeneral.doNotAllow}
                    onClick={onClose}/>
                <Button
                    className={'button-dialog'}
                    value={'confirm'}
                    title={textsGeneral.allow}
                    onClick={() => onClick()}/>
            </div>
        </DialogContent>
    </Dialog>
}

export const DialogPermissionDeniedCamera = ({open, onClose, onClick}) => {
    return <Dialog open={open}>
        <DialogTitle>
            {textsGeneral.permission}
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                {textsGeneral.permissionDeniedMessage}
            </DialogContentText>
            <div className={'div-dialog-confirmation'}>
                <Button
                    className={'button-dialog'}
                    variant={'outline'}
                    value={'cancel'}
                    title={textsGeneral.cancel}
                    onClick={onClose}/>
                <Button
                    className={'button-dialog'}
                    value={'confirm'}
                    title={textsGeneral.resetPermissions}
                    onClick={() => onClick()}/>
            </div>
        </DialogContent>
    </Dialog>
}

export const DialogOptionConsume = ({open, onClick}) => {
    const orderTakeAway = getSession('orderTakeAway', null)
    return <Dialog open={open}>
        <DialogTitle>
            {textsShoppingCart.eatHereOrTakeAway}
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                {textsShoppingCart.chooseToEatInOrTakeOut}
            </DialogContentText>
            <Box p={1}/>
            <div
                className={'div-option-scheduled'}
                id={!orderTakeAway ? 'option-selected-scheduled' : ''}
                onClick={() => onClick(false)}>
                <div>
                    <label className={'label-option'}>
                        {textsGeneral.consumeInStore}
                    </label>
                </div>
                <Box p={2}/>
                <CheckCircleRounded
                    className={'icon-select-option'}
                    id={!orderTakeAway ? 'icon-selected-scheduled' : ''}/>
            </div>
            <div className={'div-option-scheduled'} id={orderTakeAway ? 'option-selected-scheduled' : ''}
                 onClick={() => onClick(true)}>
                <div>
                    <label className={'label-option'}>
                        {textsGeneral.pickUpOrderToTakeAway}
                    </label>
                </div>
                <Box p={2}/>
                <CheckCircleRounded
                    className={'icon-select-option'}
                    id={orderTakeAway ? 'icon-selected-scheduled' : ''}/>
            </div>
        </DialogContent>
    </Dialog>
}

export const DialogAddCard = ({open, cards, onClose, onClickAdd, onClickRemove, onClickConsult}) => {
    return <Dialog open={open} onClose={onClose}>
        <DialogTitle>
            {textsGeneral.toAdd}
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                {textsGeneral.wantToAddCard}
            </DialogContentText>
            <div className={'div-cards-consultation'}>
                {cards.map((card, i) => <div key={i} className={'div-card'} onClick={() => onClickRemove(card)}>
                        <label className={'label'}>{card}</label>
                        <div className={'div-icon'}>
                            <DeleteRounded className={'icon'}/>
                        </div>
                    </div>
                )}
            </div>
            <div className={'div-dialog-confirmation-row'}>
                <Button
                    className={'button-dialog-row'}
                    value={'confirm'}
                    title={textsConsultation.toConsult}
                    onClick={onClickConsult}/>
                <Button
                    className={'button-dialog-row'}
                    variant={'outline'}
                    value={'cancel'}
                    title={textsGeneral.toAdd}
                    onClick={onClickAdd}/>
                <Button
                    className={'button-dialog-row'}
                    variant={'text'}
                    value={'confirm'}
                    title={textsGeneral.toClose}
                    onClick={onClose}/>
            </div>
        </DialogContent>
    </Dialog>
}

export const DialogPix = ({open, qrcode, value, onClose, onClick}) => {
    return <Dialog open={open}>
        <DialogTitle>
            PIX
        </DialogTitle>
        <DialogContent>
            <DialogContentText id={'description-pix'}>
                {`Faça o pagamento de sua conta via PIX, valor ${(value || 0).toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                })}`}
            </DialogContentText>
            <Pix qrcode={qrcode}/>
            <div className={'div-dialog-confirmation-row'}>
                <Button
                    className={'button-dialog-row'}
                    value={'confirm'}
                    title={'Copiar PIX'}
                    onClick={() => onClick(qrcode)}/>
                <Button
                    className={'button-dialog-row'}
                    variant={'text'}
                    value={'confirm'}
                    title={textsGeneral.toClose}
                    onClick={onClose}/>
            </div>
        </DialogContent>
    </Dialog>
}

export const DialogSuccessPayment = ({open, nfe, onClick}) => {
    useEffect(() => {
        const id = setTimeout(() => onClick(), 10000)

        return () => {
            clearTimeout(id)
        }
    }, [])
    return <Dialog open={open}>
        <DialogContent>
            <div className={'div-dialog-sending-success'}>
                <Lottie
                    animationData={checked}
                    className={'lottie-sending-success'}/>
                <label className={'label-dialog-loading'}>
                    {textsConsultation.pixPaymentSuccessfully}
                </label>
            </div>
            <Button
                style={{width: '100%'}}
                className={'button-dialog'}
                value={'cancel'}
                title={nfe ? textsConsultation.openTaxNoteLink : textsGeneral.confirm}
                onClick={() => onClick(nfe)}
            />
        </DialogContent>
    </Dialog>
}

/* fullScreen */

export const DialogOrderConfirmation = ({open, cashback, onEdit, onClick, onClose}) => {
    const {restartButton} = useContext(ShoppingCartContext)
    const [textoBotao, setTextoBotao] = useState('')
    const [enable, setEnable] = useState(false)
    const [time, setTime] = useState('')

    const handlePressKeyboard = event => {
        if (event.key === 'Escape') {
            onClose()
        } else if (event.key === 'F8') {
            onClick()
        }
    }

    useEffect(() => {
        document.addEventListener('keydown', handlePressKeyboard, false)
        return () => document.removeEventListener('keydown', handlePressKeyboard, false)
    }, [])

    useEffect(() => {
        setTextoBotao('Aguardando revisão do pedido')
        setEnable(false)
        setTime('')

        const tempoTotal = 6000
        const intervalo = 1500

        const timeouts = []

        timeouts.push(setTimeout(() => {
            setTextoBotao(textsGeneral.reviewTable)
            setTime('3')
        }, intervalo))

        timeouts.push(setTimeout(() => {
            setTextoBotao(textsGeneral.reviewTheValues)
            setTime('2')
        }, intervalo * 2))

        timeouts.push(setTimeout(() => {
            setTextoBotao(textsGeneral.reviewTheOrderInformation)
            setTime('1')
        }, intervalo * 3))

        timeouts.push(setTimeout(() => {
            setTextoBotao(`${textsShoppingCart.sendRequest} - ${totalOrder.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            })}`)
            setEnable(true)
            setTime('')
        }, tempoTotal))

        return () => {
            timeouts.forEach(timeout => clearTimeout(timeout))
        }
    }, [restartButton])

    const totalItems = getSession('totalItems', 0)
    const discount = getSession('discount', 0)
    const discountCoupon = getSession('discountCoupon', '')
    const rescue = getSession('rescue', 0)
    const totalOrder = ((totalItems - discount) - rescue)
    const profile = getLocal('profile', {})
    const mode = getSession('mode', '')
    const table = getSession('table', '')
    const identifyTableManually = getLocal('identifyTableManually')
    const payment = getSession('payment')
    const showOptionTakeAway = getLocal('showOptionTakeAway', false)
    const orderTakeAway = getSession('orderTakeAway', null)
    const confirm = () => onClick()
    const handleClickEdit = (type) => onEdit(type)

    return <Dialog
        open={open}
        onClose={onClose}
        fullScreen={isMobile()}
        keepMounted
        PaperProps={{
            style: isMobile() ? {borderRadius: 0, padding: 0} : {width: 500, minHeight: '91vh'}
        }}>
        <DialogTitle id={'dialog-title'}>
            <ArrowBackIcon className={'icon-close'} onClick={onClose}/>
            {textsShoppingCart.reviewInformation}
        </DialogTitle>
        <DialogContent style={{padding: 0}}>
            <motion.div
                initial={{x: 400}}
                animate={{x: 0}}
                transition={{duration: 0.3}}>
                <div className={'div-order-confirmation'}>
                    <div className={'div-container-confirmation'}>
                        {((mode !== 'desk') || (mode === 'desk' && identifyTableManually)) &&
                            <div className={'div-data-order-address'}
                                 onClick={(mode === 'card' || identifyTableManually) ? (() => handleClickEdit('table')) : ({})}>
                                <div className={'div-data-item-address'}>
                                    <div className={'div-mode'}>
                                        <label className={'label-mode'}>
                                            {textsGeneral.table}
                                        </label>
                                        {(mode === 'card') && <ExpandMoreRounded color={'secondary'}/>}
                                    </div>
                                    <label className={'description'}>
                                        {`${textsGeneral.numberTable}: ${table}`}
                                    </label>
                                </div>
                            </div>
                        }
                        {(mode === 'desk') && <div className={'div-data-order'}>
                            <div className={'div-descriptions'}>
                                {paymentIcon(payment)}
                                <div className={'descriptions'}>
                                    <label className={'title'}>
                                        {textsGeneral.payment}
                                    </label>
                                    <label className={'description'}>
                                        {payment.description}
                                    </label>
                                </div>
                            </div>
                            <div className={'button'} onClick={() => handleClickEdit('payment')}>
                                <label className={'label'}>
                                    {textsItemBag.toReplace}
                                </label>
                            </div>
                        </div>}
                        {(showOptionTakeAway) &&
                            <div className={'div-data-order'}>
                                <div className={'div-descriptions'}>
                                    <RestaurantRounded className={'icon'}/>
                                    <div className={'descriptions'}>
                                        <label className={'title'}>
                                            {textsItemBag.order}
                                        </label>
                                        <label className={'description'}>
                                            {orderTakeAway ? textsGeneral.pickUpOrderToTakeAway : textsGeneral.consumeInStore}
                                        </label>
                                    </div>
                                </div>
                                <div className={'button'} onClick={() => handleClickEdit('typeOrder')}>
                                    <label className={'label'}>
                                        {textsItemBag.toReplace}
                                    </label>
                                </div>
                            </div>
                        }
                        <div className={'div-data-order'}>
                            <div className={'div-descriptions'}>
                                <Receipt className={'icon'}/>
                                <div className={'descriptions'}>
                                    <label className={'title'}>
                                        {textsGeneral.identification}
                                    </label>
                                    <label className={'description'}>
                                        {profile.name}
                                    </label>
                                </div>
                            </div>
                            <div className={'button'} onClick={() => handleClickEdit('cpf')}>
                                <label className={'label'}>
                                    {textsItemBag.toReplace}
                                </label>
                            </div>
                        </div>
                        {(!!cashback?.balance) && <div className={'div-data-order'}>
                            <div className={'div-descriptions'}>
                                <CurrencyExchangeRounded className={'icon'}/>
                                <div className={'descriptions'}>
                                    <label className={'title'}>
                                        {textsShoppingCart.cashback}
                                    </label>
                                    <label className={'description'}>
                                        {(cashback.balance - rescue).toLocaleString('pt-BR', {
                                            style: 'currency',
                                            currency: 'BRL'
                                        })}
                                    </label>
                                </div>
                            </div>
                            <div className={'button'} onClick={() => handleClickEdit('cashback')}>
                                <label className={'label'}>
                                    {(rescue) ? textsItemBag.toAlter : textsGeneral.rescue}
                                </label>
                            </div>
                        </div>}
                        {/*<div className={'div-data-order'}>*/}
                        {/*    <div className={'div-descriptions'}>*/}
                        {/*        <Discount className={'icon'}/>*/}
                        {/*        <div className={'descriptions'}>*/}
                        {/*            <label className={'title'}>*/}
                        {/*                {textsGeneral.discountCoupon}*/}
                        {/*            </label>*/}
                        {/*            <label className={'description'}>*/}
                        {/*                {!discountCoupon ? textsItemBag.notApplied : discountCoupon.discountCoupon}*/}
                        {/*            </label>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*    <div className={'button'} onClick={() => handleClickEdit('discountCoupon')}>*/}
                        {/*        <label className={'label'}>*/}
                        {/*            {!discountCoupon ? textsItemBag.toAdd : textsItemBag.toReplace}*/}
                        {/*        </label>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        <div className={'div-data-order-summary-values'}>
                            <div className={'div-title'}>
                                <label className={'title'}>
                                    {textsItemBag.summaryValues}
                                </label>
                            </div>
                            <div className={'div-values'}>
                                <label className={'description'}>
                                    {textsShoppingCart.subtotal}
                                </label>
                                <label className={'value'}>
                                    {totalItems.toLocaleString('pt-BR', {
                                        style: 'currency',
                                        currency: 'BRL'
                                    })}
                                </label>
                            </div>
                            {(discount > 0) && <div className={'div-values'}>
                                <label className={'description'}>
                                    {textsShoppingCart.discount}
                                </label>
                                <label className={'value'}>
                                    {`- ${discount.toLocaleString('pt-BR', {
                                        style: 'currency',
                                        currency: 'BRL'
                                    })}`}
                                </label>
                            </div>}
                            {(rescue > 0) && <div className={'div-values'}>
                                <label className={'description'}>
                                    {textsShoppingCart.cashback}
                                </label>
                                <label className={'value'}>
                                    {`- ${rescue.toLocaleString('pt-BR', {
                                        style: 'currency',
                                        currency: 'BRL'
                                    })}`}
                                </label>
                            </div>}
                            <div className={'div-values'}>
                                <label className={'description'} style={{fontSize: 16, fontWeight: 'bold'}}>
                                    {textsShoppingCart.total}
                                </label>
                                <label className={'description'} style={{fontSize: 16, fontWeight: 'bold'}}>
                                    {totalOrder.toLocaleString('pt-BR', {
                                        style: 'currency',
                                        currency: 'BRL'
                                    })}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </motion.div>
        </DialogContent>
        <div className={'div-buttons-order-confirmation'}>
            <ButtonTimer
                className={'button-dialog-confirmation'}
                value={'confirm'}
                title={textoBotao}
                time={time}
                enable={enable}
                onClick={() => confirm()}
            />
        </div>
    </Dialog>
}

const paymentIcon = (payment) => {
    if (payment.code === 'PIX') return <PixIcon className={'icon-pix'}/>
    else return <CreditCardIcon className={'icon'}/>
}

export const DialogHistory = ({open, onClose, onClick}) => {
    const history = getLocal('history', [])
    const handleClick = order => onClick(order)
    return <Dialog
        open={open}
        onClose={onClose}
        fullScreen={isMobile()}
        PaperProps={{
            style: isMobile() ? {borderRadius: 0, padding: 0} : {width: 500}
        }}>
        <DialogTitle id={'dialog-title'}>
            <ArrowBackIcon className={'icon-close'} onClick={onClose}/>
            {textsGeneral.orderHistory}
        </DialogTitle>
        <DialogContent sx={{padding: 0}}>
            <ListHistory history={history} onClick={handleClick}/>
        </DialogContent>
    </Dialog>
}

export const DialogMyOrder = ({open, order, onClose}) => {
    return <Dialog
        open={open}
        onClose={onClose}
        fullScreen={isMobile()}
        PaperProps={{
            style: isMobile() ? {borderRadius: 0, padding: 0} : {width: 500}
        }}>
        <DialogTitle id={'dialog-title'}>
            <ArrowBackIcon className={'icon-close'} onClick={onClose}/>
            {textsGeneral.myOrder}
        </DialogTitle>
        <DialogContent sx={{padding: 0}}>
            <Order order={order}/>
        </DialogContent>
    </Dialog>
}

export const DialogPaymentMethods = ({open, onClose, onClick}) => {

    const handleClickPayment = (payment) => onClick(payment)

    return <Dialog
        open={open}
        onClose={onClose}
        fullScreen={isMobile()}
        PaperProps={{
            style: isMobile() ? {borderRadius: 0, padding: 0} : {width: 500, minHeight: '91vh'}
        }}>
        <DialogTitle id={'dialog-title'}>
            <ArrowBackIcon className={'icon-close'} onClick={onClose}/>
            {textsGeneral.paymentMethods}
        </DialogTitle>
        <DialogContent style={{padding: 0}}>
            <PaymentTypes onClick={handleClickPayment}/>
        </DialogContent>
    </Dialog>
}

export const DialogAddCardCredit = ({open, onClose, onClick}) => {
    return <Dialog
        open={open}
        onClose={onClose}
        fullScreen={isMobile()}
        PaperProps={{style: isMobile() ? {borderRadius: 0, padding: 0} : {width: 500, minHeight: '91vh'}}}>
        <DialogTitle id={'dialog-title'}>
            <ArrowBackIcon className={'icon-close'} onClick={onClose}/>
            {textsAddCard.addCard}
        </DialogTitle>
        <DialogContent style={{padding: 0}}>
            <AddCardCredit onClick={onClick}/>
        </DialogContent>
    </Dialog>
}
